<template>
  <div>
    <a-modal width="700px" v-model="isShow" :closable="false" :title="title" :afterClose="handleCancel" :maskClosable="false">
      <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
        <a-form-model-item label="归属业务线" prop="line_id">
          <a-select v-model="form.line_id" :disabled="isEdit" allowClear show-search option-filter-prop="children" placeholder="请选择业务线" style="width: 100%">
            <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="专题标题" prop="title">
          <a-input v-model.trim="form.title" allowClear :maxLength="15" placeholder="请输入专题标题" />
        </a-form-model-item>
        <a-form-model-item label="发布时间" prop="release_time">
          <a-date-picker v-model="form.release_time" style="width: 100%;" :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm" placeholder="发布时间" @change="onChange" />
        </a-form-model-item>
        <a-form-model-item label="专题头图" prop="head_img">
          <a-upload accept=".jpg, .jpeg, .png" :headers="{ token }" :file-list="smetaList" :action="`${baseURL}/public/upload-file-qi-niu`" :before-upload="beforeUpload" list-type="picture-card" @preview="handlePreview" @change="(data) => handleChange(data)">
            <div v-if="smetaList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">
                Upload
              </div>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="专题内容" prop="content">
          <a-textarea v-model.trim="form.content" placeholder="请输入专题内容" allowClear :maxLength="150" :auto-size="{ minRows: 4, maxRows: 5 }" />
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> 取 消 </a-button>
        <a-button key="submit" type="primary" :loading="btnloading" @click="handleSubmit"> 提 交 </a-button>
      </template>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, defineComponent, onMounted, watch, computed } from '@vue/composition-api'
import { form, rules } from '../business/filialeList'
import dialog from '@/composables/dialog'
import token from '@/composables/token'
import compuedFun from '../business/index'
import moment from 'moment'
import api from '@/api/'
import storeGlobal from '@/store/'
import login from '@/api/login'

const title = {
  Add: '新增专题',
  Edit: '编辑专题'
}

export default defineComponent({
  mixins: [dialog],
  props: {
    platformList: {
      type: [Object, Array],
      default() {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: {}
    }
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      rules,
      smetaList: [],
      baseURL: process.env.VUE_APP_API_BASE_URL,
      title: title.Add,
      btnloading: false,
      previewImage: '',
      previewVisible: false,
      times: '',
      form: { ...form }
    })

    watch(
      () => _this.params,
      async () => {
        state.smetaList.push({
          uid: '-1',
          name: _this.params.title,
          status: 'done',
          url: _this.params.head_img
        })
        state.form = JSON.parse(JSON.stringify({ ..._this.params }))
        state.form.line_id = state.form?.line_id ? Number(state.form?.line_id) : undefined
        state.form.release_time = moment(_this.params.release_time * 1000).format('YYYY-MM-DD HH:mm:ss')
      }
    )

    watch(
      () => _this.isEdit,
      async () => {
        state.title = _this.isEdit ? title.Edit : title.Add
      }
    )
    // crea
    const methods = {
      handleChange(data) {
        state.smetaList = data.fileList
        state.form.head_img = data.fileList[0]?.response
          ? _this.QI_NIU_DOMAINS + '/' + data.fileList[0].response.data.url
          : ''
      },
      handlePreview(file) {
        this.previewImage = file.url || _this.QI_NIU_DOMAINS + '/' + file.response.data.url
        this.previewVisible = true
      },
      beforeUpload(file) {
        return new Promise((resolve, reject) => {
          const isJpgOrPng =
            file.type === 'image/jpeg' ||
            file.type === 'image/png' ||
            file.type === 'image/png' ||
            file.type === 'image/gif'
          if (!isJpgOrPng) {
            this.$message.error('请上传图片!')
            return reject(new Error(false))
          }
          const isLt2M = file.size / 1024 / 1024 <= 2
          if (!isLt2M) {
            this.$message.error('图片大小不超过 2MB!')
            return reject(new Error(false))
          }
          return resolve(true)
        })
      },
      onChange(value, dateString) {
        state.form.release_time = dateString
      },
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async valid => {
          let res = null
          const data = { ...state.form }
          if (valid) {
            if (_this.isEdit) {
              res = await api.updataSpecial(data)
            } else {
              res = await api.createSpecial(data)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.isShow = false
              state.btnloading = false
              _this.$emit('handleOver')
              _this.$refs.formDom.resetFields()
            } else {
              state.btnloading = false
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.times = ''
        _this.smetaList = []
        _this.isShow = false
      }
    }
    return {
      ...toRefs(state),
      ...compuedFun(),
      ...token(),
      ...methods
    }
  }
})
</script>
